export default "__VITE_ASSET__fe8d87d9__"